import { Injectable } from '@angular/core';
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({
    providedIn: 'root'
})
export class CurrentUserRolesProvider {
    private _currentUserOrganizationsRolesIdsCache: any = {};
    constructor(
        private _conf: ConfigProvider,
        private _utils: UtilsProvider,
        private _currentUser: CurrentUser,
    ) { }

    public getRolesIds(organizationId: number): number[] {
        if (!this._currentUser.isLoggedIn()) {
            return [];
        }
        let roles: number[] = [];
        this._currentUser.user?.organizationMemberships?.forEach((membership) => {
            if (membership.organizationId === organizationId) {
                const userRoles = membership.organizationRoles.map((role) => role.id!);
                if (userRoles)
                  roles = userRoles;
            }
        });
        return roles;
    }

    public have(roleId: number, organizationId: number): boolean{
        const rolesIds = this.getRolesIds(organizationId);
        return (rolesIds.indexOf(roleId) > -1);
    }

    public updateRolesCache(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (!this._currentUser.isLoggedIn()) {
                resolve(null);
                return;
            }
            // this.api.call('GET', `users/${this._currentUser.user.id}/organizationMemberships`, {}, this._currentUser.getAccessToken())
            // this._storage.select(OrganizationMembership)
            //     .where('userId').equals(this._currentUser.user.id)
            //     .get()
            //     .then((memberships: OrganizationMembership[]) => {
            //         this._storage.select(OrganizationMembership_OrganizationRole)
            //             .where('organizationMembershipId').in(this._utils.getKeyValues(memberships, 'id'))
            //             .get()
            //             .then((roles: OrganizationMembership_OrganizationRole[]) => {
            //                 const cache: any = {};
            //                 for (let i = 0; i < memberships.length; i++) {
            //                     const orgaRoles: OrganizationMembership_OrganizationRole[] = this._utils.findManyIn(
            //                         [memberships[i].id],
            //                         roles,
            //                         'organizationMembershipId'
            //                     );
            //                     cache['_' + memberships[i].organizationId] = this._utils.getKeyValues(orgaRoles, 'organizationRoleId');
            //                 }
            //
            //                 this._currentUserOrganizationsRolesIdsCache = cache;
            //                 resolve();
            //             })
            //             .catch((error: any) => reject(error));
            //     })
            //     .catch((error: any) => { });
        });
    }

    // public getSyncListeners(): SyncListener[] {
    //     return [{
    //         id: '',
    //         onCommonDataSynced: null,
    //         onUserDataSynced: (rawData: any) => {
    //             if (rawData.organizationMemberships.length || rawData.organizationMembership_organizationRoles.length) {
    //                 this.updateRolesCache().catch((error: any) => {
    //                     console.log('Failed to update current user roles cache.');
    //                 });
    //             }
    //         }
    //     }];
    // }
}
